<!-- Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved. -->

<h2 id="AddOrganizationDialog" mat-dialog-title appLifecycleTracker trackerName="add-organization-dialog">{{fTitle}}</h2>

<mat-dialog-content>
  <form id="registerForm" [formGroup]="registerForm" class="register-form">
      <div class="controls-row">
          <mat-form-field class="company-name" appearance="outline">
            <mat-label>{{fCompany}}</mat-label>
              <input id="registerFormCompany" matInput type="text" formControlName="company" placeholder="{{fCompany}}" maxlength="255" />
              <mat-error *ngIf="registerForm.controls['company'].errors?.required">{{'COMPANY_NAME_REQ' | translate}}</mat-error>
          </mat-form-field>

          <mat-form-field  *ngIf="choosePlan" appearance="outline">
              <mat-label>{{'L_PRODUCT' | translate}}</mat-label>
              <mat-select formControlName="edition" [value]="PlanChoiceValue.PLUS" (valueChange)="onEditionChanged($event)">
                <mat-option *ngIf="this.bitLockerCount" id="bitlocker-option" [value]="PlanChoiceValue.BITLOCKER">{{ 'product_and_plan.plan.bitlocker-label' | translate }}</mat-option>
                <mat-option *ngIf="this.plusCount"  id="d3eBusiness-option" [value]="PlanChoiceValue.PLUS">{{fBusiness}}</mat-option>
                <mat-option *ngIf="this.hardwareCount"  id="hardware-option" [value]="PlanChoiceValue.HARDWARE">{{ 'product_and_plan.plan.hardware-label' | translate }}</mat-option>
                <mat-option *ngIf="this.hardware2Count" id="hardware2-option" [value]="PlanChoiceValue.HARDWARE2">{{ 'product_and_plan.plan.hardware2-label' | translate }}</mat-option>
                <mat-option *ngIf="this.fdeCount" id="fde-option" [value]="PlanChoiceValue.FDE">{{ 'product_and_plan.plan.fde-label' | translate }}</mat-option>
                <mat-option *ngIf="this.agentCount" id="agent-option" [value]="PlanChoiceValue.AGENT">{{ 'product_and_plan.plan.agent-label' | translate }}</mat-option>
              </mat-select>
          </mat-form-field>
      </div>

      <div>
          <mat-form-field class="email" appearance="outline">
              <mat-label>{{fEmail}}</mat-label>
              <input  id="registerFormEmail" matInput type="email" formControlName="email" placeholder="{{fEmail}}" (blur)="onEmailBlur()" />
              <mat-error *ngIf="registerForm.controls['email'].errors?.required">{{'EMAIL_REQ' | translate}}</mat-error>
              <mat-error *ngIf="registerForm.controls['email'].errors?.exists">{{fExists}}</mat-error>
              <mat-error *ngIf="registerForm.controls['email'].errors?.pattern">{{fEMailInvalid}}</mat-error>
          </mat-form-field>

          <span *ngIf="user?.org_type?.manage_child && selectedEdition !== 'hardware' && selectedEdition !== 'hardware2'
                && selectedEdition !== 'fde'">
              <mat-checkbox class="" color="primary" formControlName="reserve_domain">{{'reserve-domain.checkbox-label' | translate}}</mat-checkbox>
          </span>

          <span *ngIf="data.enableEndpointMap && selectedEdition !== 'hardware' && selectedEdition !== 'hardware2'
                && selectedEdition !== 'fde'">
              <mat-checkbox class="" color="primary" formControlName="enableEndpointMap">{{'enable-endpoint-map.checkbox-label' | translate}}</mat-checkbox>
          </span>
      </div>

      <div class="controls-row">
          <mat-form-field class="password-field" appearance="outline">
              <mat-label>{{fPassword}}</mat-label>
              <input id="registerFormPassword" type="input" formControlName="password"  matInput placeholder="{{fPassword}}" readonly #passwordInput />
          </mat-form-field>
          <button id="registerFormCopyPassword" mat-mini-fab (click)="copyPasswordToClipboard()" color="primary" matTooltip="{{fCopy}}" aria-label="Copy password to clipboard">
              <span class="mdi mdi-content-copy copy-icon"></span>
          </button>
      </div>

      <div class="controls-row">
          <mat-form-field appearance="outline">
              <mat-label>{{fFName}}</mat-label>
              <input id="registerFormFname" matInput type="text" formControlName="fname" placeholder="{{fFName}}" maxlength="255" />
              <mat-error *ngIf="registerForm.controls['fname'].errors?.required">{{'ADU_FIRST_REQ' | translate}}</mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline">
              <mat-label>{{fLName}}</mat-label>
              <input id="registerFormLname" matInput type="text" formControlName="lname" placeholder="{{fLName}}" maxlength="255" />
              <mat-error *ngIf="registerForm.controls['lname'].errors?.required">{{'ADU_LAST_REQ' | translate}}</mat-error>
          </mat-form-field>
      </div>

      <div class="controls-row">
          <mat-checkbox color="primary" class="send-email-checkbox" formControlName="sendEmail">{{fNotify}}</mat-checkbox>
          <app-language-selector
              label=""
              [disabled]="doNotSendEmail"
              [selectedLanguage]="selectedLanguage"
              (valueChange)="onLanguageChanged($event)">
          </app-language-selector>
      </div>

      <mat-divider class="divider"></mat-divider>

      <div *ngIf="selectedEdition === 'hardware' || selectedEdition === 'hardware2'" class="max-drive">
        <span style="width: 45%">{{'organizations.sub.max-drive-label' | translate}}</span><span>{{ maxDrivePerInstallation }}</span>
      </div>

      <div *ngIf="selectedEdition !== 'hardware' && selectedEdition !== 'hardware2' && selectedEdition !== 'fde'">
          <mat-checkbox id="generateKeysCheckbox" class="key-gen-checkbox" color="primary"
                        formControlName="generateKeys"
                        (change)="changePasswordEnabled($event)">
            {{'APU_GEN_KEYS' | translate}}
          </mat-checkbox>
          <mat-form-field class="key-pass" appearance="outline">
              <mat-label>{{'APU_KEY_PASS' | translate}}</mat-label>
              <input matInput type="text" formControlName="keyPassword" placeholder="{{'APU_KEY_PASS' | translate}}">
          </mat-form-field>
      </div>

      <div class="controls-row">
          @if (selectedEdition == 'hardware' || selectedEdition == 'hardware2') {
              <mat-form-field appearance="outline">
                  <mat-label>{{ 'ADO_EXPIRES' | translate }}</mat-label>
                  <input matInput value="{{ 'NON_EXPIRING' | translate }}" [disabled]="true">
              </mat-form-field>
          } @else {
              <mat-form-field [ngStyle]="{'width': '45%'}" appearance="outline">
                  <mat-label>{{'ADO_EXPIRES' | translate}}</mat-label>
                  <input matInput [matDatepicker]="myExpDatepicker" formControlName="expirationDate"
                         [min]="this.minDate" [max]="this.maxDate" (click)="myExpDatepicker.open()"
                         (dateChange)="onExpirationChanged()">
                  <mat-datepicker-toggle matSuffix [for]="myExpDatepicker"></mat-datepicker-toggle>
                  <mat-datepicker #myExpDatepicker></mat-datepicker>
              </mat-form-field>
          }

          <mat-form-field [ngStyle]="{'width': '45%'}" appearance="outline">
              <mat-label>{{'MAINT_EXPIRES' | translate}}</mat-label>
              <input matInput [matDatepicker]="myMaintDatepicker" formControlName="maintenance_end"
                     [min]="this.minDate" [max]="this.maxDate" (click)="myMaintDatepicker.open()">
              <mat-datepicker-toggle matSuffix [for]="myMaintDatepicker"></mat-datepicker-toggle>
              <mat-datepicker #myMaintDatepicker></mat-datepicker>
          </mat-form-field>
      </div>

      <div class="controls-row" *ngIf="selectedEdition !== 'hardware' && selectedEdition !== 'hardware2' && selectedEdition !== 'fde'">
          <mat-form-field [ngStyle]="{'width': '45%'}" appearance="outline">
              <mat-label>{{fDelay}}</mat-label>
              <input id="editDurationDelay" matInput type="number" min=0 max="6" #durationDelay
                     (change)="onDelayChange($event)"/>
          </mat-form-field>&nbsp;

          <span>{{ 'ADO_DURATION' | translate }}</span>
      </div>

      <div class="controls-row">
          <mat-form-field appearance="outline">
              <mat-label>{{fLicenses}}</mat-label>
              <input id="registerFormLicenses" matInput min="1" [max]="selectedPlanCount" type="number" formControlName="licenses" placeholder="{{fLicenses}}" />
              <mat-error *ngIf="registerForm.controls['licenses'].errors?.required">{{'ESC_COUNT_REQ' | translate}}</mat-error>
          </mat-form-field>
          <span>{{selectedPlanCount}} {{fAvailable}}</span>
      </div>

      <div>

        <span *ngIf="selectedEdition !== 'hardware' && selectedEdition !== 'hardware2' && selectedEdition !== 'fde'"
                class="policy-selector">
          <mat-form-field appearance="outline">
              <mat-label>{{fDefault}}</mat-label>
              <mat-select formControlName="defaultPolicy">
                  <mat-option value="-1">{{fSystemDefault}}</mat-option>
                  <mat-option *ngFor="let policy of policies" [value]="policy.id.toString()">
                      {{policy.name}}
                  </mat-option>
              </mat-select>
          </mat-form-field>
        </span>

        <mat-form-field *ngIf="user?.org_type?.create_child && user?.partnerId == null" appearance="outline">
            <mat-label >{{'PARTNER' | translate}}</mat-label>
            <mat-select formControlName="partnerId" (valueChange)="onPartnerChanged($event)">
                <mat-option value="-1">{{fSystemDefault}}</mat-option>
                <mat-option *ngFor="let partner of partners" [value]="partner.id.toString()">
                    {{partner.name}}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field *ngIf="selectedEdition !== 'hardware' && selectedEdition !== 'hardware2' && selectedEdition !== 'fde'"
                        appearance="outline">
            <mat-label >{{"organizations.sub.type_label" | translate}}</mat-label>
            <mat-select [(value)]="subType">
                <mat-option id="subType" *ngFor="let type of subTypes" [value]="type">
                    {{"organizations.sub.type." + type.label | translate}}
              </mat-option>
            </mat-select>
        </mat-form-field>

        <div *ngIf="selectedEdition === 'hardware' || selectedEdition === 'd3eBusiness' || selectedEdition === 'hardware2'" class="single-row">
            <mat-checkbox color="primary" formControlName="enablePBAExtendedFeatures">
              <span class="checkbox-with-icon">
                <span>{{'organizations.sub.enable-features-label' | translate}}</span>
                <span tabindex="0"
                      aria-label="Includes TPM and non-interactive Security Key"
                      matTooltip="Includes TPM and non-interactive Security Key"
                      matTooltipPosition="right">
                    <span class="mdi mdi-information-outline circle-info-icon"></span>
                </span>
              </span>
            </mat-checkbox>
        </div>

        <div *ngIf="selectedEdition === 'hardware' || selectedEdition === 'd3eBusiness' || selectedEdition === 'hardware2'" class="single-row">
            <mat-checkbox color="primary" class="pba-features-checkbox" formControlName="enablePBALogErase">
            <span>{{'organizations.sub.enable-log-erase-label' | translate}}</span>
            </mat-checkbox>
        </div>

      </div>

  </form>
</mat-dialog-content>

<div mat-dialog-actions class="button-wrapper">
    <button id="AddOrganizationDialogCancel" mat-raised-button
            (click)="onCancelClick()"
            type="button">
        {{fCancel}}
    </button>
    <button id="AddOrganizationDialogSave" mat-raised-button
            (click)="onSubmit()"
            [disabled]="!registerForm.valid || checkingEmailExists || invalidExpiration || invalidDelay"
            type="button"
            color="primary">
        {{fSave}}
    </button>
</div>
